import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import styledWithTheme from 'foundations-theming/utils';
import { mobileScreen, trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { HUBSPOT_CREDITS_VALUE_PROPOSITIONS } from '../../v2/constants/tracking/TrackingSources';
import { useHubSpotCreditsInventoryInfo } from '../../v2/hooks/inventory/useHubSpotCreditsInventoryInfo';
import { getHubSpotCreditsHeroImage } from '../key-features/getLocalizedImages';
import BuyAdditionalCreditsCard from './BuyAdditionalCreditsCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeroSection = styledWithTheme.section(({
  theme
}) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[800],
    paddingBlock: theme.space[1300],
    [trellisBreakpoint[mobileScreen]]: {
      paddingInline: theme.space[300],
      paddingBlockStart: theme.space[0],
      paddingBlockEnd: theme.space[800]
    }
  };
});
const HubSpotCreditsHero = ({
  navItem
}) => {
  const isSmallerThanCs = useMedia('cs');
  const {
    ownedHubSpotCreditsTotal,
    loading: hubSpotCreditsLoading
  } = useHubSpotCreditsInventoryInfo();
  const ownsAdditionalCredits = !hubSpotCreditsLoading && ownedHubSpotCreditsTotal > 0;
  return /*#__PURE__*/_jsxs(HeroSection, {
    children: [/*#__PURE__*/_jsx(View, {
      as: "header",
      flexBasis: "100%",
      flex: 1,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "600",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.hubspot-credits.pageTitle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.hero.headline"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: ownsAdditionalCredits ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.hero.description.ownsAdditional"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.hero.description.default"
          })
        })]
      })
    }), (ownsAdditionalCredits || !isSmallerThanCs) && /*#__PURE__*/_jsx(Flex, {
      flexBasis: "100%",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      children: ownsAdditionalCredits ? /*#__PURE__*/_jsx(BuyAdditionalCreditsCard, {
        trackingSource: HUBSPOT_CREDITS_VALUE_PROPOSITIONS,
        screen: navItem
      }) : /*#__PURE__*/_jsx(Image, {
        src: getHubSpotCreditsHeroImage(),
        alt: I18n.text('pricingPage.pages.hubspot-credits.hero.alt')
      })
    })]
  });
};
export default HubSpotCreditsHero;